// sort-imports-ignore
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { createRoot } from "react-dom/client";

import WalletAuthProvider from "src/components/WalletAuthProvider";

import "src/global.css";
import theme from "src/theme";

import App from "src/App";

const root = createRoot(document.getElementById("root"));

// NOTE: No <StrictMode>. In dev, StrictMode double-invokes effects, which makes
// Privy run the OAuth code-exchange (/oauth/authenticate) twice — the second
// call fails with 401 "Invalid code during OAuth flow" (invalid_credentials)
// because the first already consumed the one-time code.
root.render(
    <ThemeProvider theme={theme}>
        <WalletAuthProvider>
            <CssBaseline>
                <App />
            </CssBaseline>
        </WalletAuthProvider>
    </ThemeProvider>,
);
